export const ALLOWED_WEBHOOK_PORT = '443'

export type WebhookUrlProblem = 'invalid URL' | 'https required' | 'credentials not allowed' | 'port not allowed'

export interface WebhookUrlOptions {
  /** On-prem only (SP_STS_ALLOW_INSECURE): accept http and any port. Never derived from customer input. */
  allowInsecure?: boolean
}

/**
 * The structural webhook URL rules, with no Node-only dependencies so the browser form and the server guard
 * (safeUrl.ts) share one definition. Rules that need DNS or IP ranges (loopback, private, metadata) cannot run in the
 * browser and stay server-side only.
 */
export const getWebhookUrlProblem = (
  rawUrl: string,
  { allowInsecure = false }: WebhookUrlOptions = {},
): { url: URL } | { problem: WebhookUrlProblem } => {
  let url: URL
  try {
    url = new URL(rawUrl)
  } catch {
    return { problem: 'invalid URL' }
  }
  if (url.protocol !== 'https:' && !(allowInsecure && url.protocol === 'http:')) { return { problem: 'https required' } }
  if (url.username || url.password) { return { problem: 'credentials not allowed' } }
  if (!allowInsecure && url.port && url.port !== ALLOWED_WEBHOOK_PORT) { return { problem: 'port not allowed' } }
  return { url }
}
